import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('projects/list', { params });
  },
  async detail(params: any) {
    return axios.get('projects/detail', { params });
  },
  async items(params: any) {
    return axios.get('projects/items', { params });
  },
  async agreement(params: any) {
    return axios.get('projects/agreement', { params });
  },
  async audit(params: any) {
    return axios.post('projects/audit', qs.stringify(params));
  },
  async logs(params: any) {
    return axios.get('projects/logs', { params });
  },
  async option(params: any) {
    return axios.get('projects/option', { params });
  },
  async saveUserName(params: any) {
    return axios.post('projects/saveusername', qs.stringify(params))
  },
  async itemsoption(params: any) {
    return axios.get('projects/itemsoption', { params })
  }
};
